<template>
    <td-dialog
        @cancel="logInfoDialogClose"
        :title="$t(title)"
        :before-close="logInfoDialogClose"
        :visible.sync="dialogInfoVisible"
        width="480px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formLogInfo" :label-width="formLabelWidth" ref="formLogInfo" :rules="rules">
            <el-form-item :label="$t('common.RES_TYPE')" prop="sResTypeCaption">
                <td-input v-model="formLogInfo.sResTypeCaption" :disabled="disabled" width="280" :placeholder="placeholder"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATE_TYPE')" prop="sOperationTypeCaption">
                <td-input v-model="formLogInfo.sOperationTypeCaption" :disabled="disabled" width="280" :placeholder="placeholder"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATION_LEVEL')" prop="sOperationLevelCaption">
                <td-input v-model="formLogInfo.sOperationLevelCaption" :disabled="disabled" width="280" :placeholder="placeholder"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATE_TIME')" prop="dtTime">
                <td-input v-model="formLogInfo.dtTime" :placeholder="placeholder" :disabled="disabled" width="280"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATE_USER')" prop="sOperationUserName">
                <td-input v-model="formLogInfo.sOperationUserName" :disabled="disabled" width="280" :placeholder="placeholder"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATE_CLIETN')" prop="sClientIp" :placeholder="placeholder">
                <td-input v-model="formLogInfo.sClientIp" :disabled="disabled" width="280" :placeholder="placeholder"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sOperationDescribe">
                <td-input type="textarea" :rows="10" width="280" v-model="formLogInfo.sOperationDescribe" :disabled="disabled" :placeholder="placeholder"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer" style="display:none"></span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogInfoVisible', 'showItem'],
    created() {
        // 初始化数据
        this.initEditData();
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            formLogInfo: {
                sOperationTypeCaption: '',
                sOperationLevelCaption: '',
                sClientIp: '',
                sOperationDescribe: '',
                dtTime: ''
            },
            controlsPosition: 'right',
            // mq类型数组
            options: [],
            formLabelWidth: '100px',
            disabled: true,
            placeholder: ''
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formLogInfo.sOperationTypeCaption = this.showItem.sOperationTypeCaption;
            this.formLogInfo.sOperationLevelCaption = this.showItem.sOperationLevelCaption;
            this.formLogInfo.dtTime = this.showItem.dtTime;
            this.formLogInfo.sClientIp = this.showItem.sClientIp;
            this.formLogInfo.sOperationDescribe = this.showItem.sOperationDescribe;
            this.formLogInfo.sOperationUserName = this.showItem.sOperationUserName;
            this.formLogInfo.sResTypeCaption = this.showItem.sResTypeCaption;
        },
        // 关闭窗口之前需要调用的方法
        logInfoDialogClose() {
            this.$emit('logInfoDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
